import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Expand from './icon-expand.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Expand {...validProps} />;
}
SvgComponent.iconName = 'expand';

/**
 * @deprecated This is a legacy icon
 */
export const ExpandIcon = svgIconWrapper(SvgComponent);
